import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-InternalServerError',
  templateUrl: './InternalServerError.component.html',
  styleUrls: ['./InternalServerError.component.css']
})
export class InternalServerErrorComponent implements OnInit {

  constructor(private route: Router) { }
  ngOnInit() {
  }
  Login() {
      this.route.navigate(['/login']);
  };
}
